import { CoverType } from '../types';

const covers: CoverType[] = [
  {
    id: 0,
    title: 'השתלות וטיפולים מיוחדים בחו"ל',
    description: `כיסוי מלא לכל ההוצאות הרפואיות הכרוכות בהשתלות וטיפולים מיוחדים בחו"ל, כגון: כיסוי להשתלת האיבר, הוצאות הטסה, תשלום שכר מנתח וחדר ניתוח, תשלום הוצאות שהייה בחו"ל גמלה חודשית לאחר השתלת האיבר ועוד.`,
    prices: [
      8.59,
      6.46,
      7.05,
      8.13,
      12.12,
      15,
      16.1,
      18.45,
      25.72,
      34.16,
      34.16,
      34.16,
      34.16,
    ],
  },
  {
    id: 1,
    title: 'תרופות מיוחדות',
    description: 'כיסוי עבור תרופות שאינן כלולות בסל הבריאות הממלכתי או שאינן מכוסות בשל התוויה רפואית שונה מהצורך הנדרש. הכיסוי בהרחבה זו הינו עד לסכום של 1,000,000 ₪ והוא מתחדש אחת לשנה.',
    prices: [
      5.01,
      5.24,
      7.75,
      8.59,
      8.79,
      9.86,
      18.7,
      21.97,
      27.67,
      47.52,
      47.52,
      47.52,
      47.52,
    ],
  },
  {
    id: 2,
    title: 'תרופות פרימיום',
    description: 'הרחבה לכיסוי תרופות מיוחדות המאפשר כיסוי רחב לתרופות למחלת הסרטן, וכולל גם בדיקה גנטית במקרה של סרטן בשלב מתקדם ואפשרות לליווי מקצועי של חברת אונקוטסט.',
    prices: [
      2.72,
      6.19,
      7.32,
      9.93,
      13.24,
      18.26,
      25.25,
      37.34,
      48.83,
      71.72,
      71.72,
      71.72,
      71.72,
    ],
  },
  {
    id: 3,
    title: 'נתוחים וטיפולים מחליפי ניתוח בחול',
    description: 'כיסוי להוצאות רפואיות הקשורות בניתוח שבוצע בחו"ל, כגון: שכר מנתח פרטי, חדר ניתוח, הטסה רפואית וטיסה עבור מלווה, הוצאות אשפוז, אביזרים רפואיים ועוד.',
    prices: [
      4.1,
      2.73,
      3.23,
      3.71,
      4.22,
      5.04,
      16.62,
      16.62,
      17.29,
      17.29,
      17.29,
      17.29,
      17.29,
    ],
  },
  {
    id: 4,
    title: 'ניתוחים וטיפולים מחליפי ניתוח בישראל מהשקל הראשון',
    description: 'כיסוי מלא לניתוחים פרטיים ולטיפולים מחליפי ניתוח בישראל, ללא תלות בשב"ן של קופות החולים ובאופן פרטי תוך בחירת הרופא המנתח מתוך רשימת רופאים רחבה של חברת הביטוח.',
    prices: [
      23.62,
      44.48,
      77.89,
      77.89,
      107.96,
      107.96,
      172.4,
      209.97,
      308.32,
      480.86,
      480.86,
      480.86,
      480.86,
    ],
  },
  {
    id: 5,
    title: 'שירותים רפואיים אמבולטוריים וטכנולוגיות מתקדמות',
    description: 'נספח זה מעניק מגוון רחב של שירותים רפואיים שכיחים, שאינם במסגרת אשפוז בבית חולים כגון – ייעוץ רפואי בארץ ובחול, בדיקות הדמיה (כגון (CT, MRI , בדיקות הריון, פיזיויתרפיות עם החזרים של עד 80%.',
    prices: [
      9.77,
      17.67,
      34.64,
      34.64,
      26.28,
      26.28,
      27.32,
      27.32,
      45.66,
      45.66,
      86.59,
    ],
  },
  {
    id: 6,
    title: 'אבחון רפואי מהיר',
    description: 'כתב שירות זה מעניק אבחון רפואי מהיר בבית חולים פרטי במגוון מצבים רפואיים ומחלות, מטרת האבחון המהיר היא לקבוע באופן מהיר אפיוני מחלה קיימת ואבחון מצב רפואי, ללא המתנה ממושכת לתורים. האבחון מתבצע על ידי רופא מומחה וכולל ביצוע של כל הבדיקות הרפואיות האבחנתיות הנדרשות בבית החולים הפרטי אסותא (בתל אביב וחיפה)',
    prices: [2, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15],
  },
  /*{
    id: 7,
    title: 'רפואה משלימה',
    description: 'תוכן חסר',
    prices: [
      7.62,
      12.12,
      12.12,
      12.12,
      12.12,
      12.12,
      12.12,
      12.12,
      12.12,
      12.12,
      12.12,
      12.12,
    ],
  },
  {
    id: 7,
    title: 'רפואה אישית אונליין',
    description: `כתב שירות זה מעניק אפשרות להתייעץ עם רופא בשיחת וידאו באמצעות הטלפון הנייד, לקבל מרשמים לתרופות, המלצות לבדיקות המשך והפנייה למרפאה לרופאה ראשונית של ביקור רופא או חדר מיון לפי הצורך.`,
    prices: [
      10.17,
      15.04,
      15.04,
      15.04,
      15.04,
      15.04,
      15.04,
      15.04,
      15.04,
      15.04,
      15.04,
      15.04,
      15.04,
    ],
  },*/
];

export default covers;
